import React from 'react';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
export var ExternalDomainLink = function ExternalDomainLink(_ref) {
  var children = _ref.children,
    href = _ref.href;
  if (!href) {
    return /*#__PURE__*/React.createElement(Text, null, children);
  }
  return /*#__PURE__*/React.createElement(TextLink, {
    bold: true,
    rel: "noopener noreferrer",
    target: "_blank",
    href: href
  }, children);
};